<template>
  <section class="container d-flex flex-column mt-3">
    <header>
      <span class="h6">
        <router-link to="/">Início</router-link>
        /
        <router-link :to="`/${currentUniverse.slug}`">{{
          currentUniverse.name
        }}</router-link>
        / {{ currentCharacter.name }}
      </span>

      <h3 class="text-center my-3">
        {{ currentCharacter.name }} - {{ currentCharacter.title }}
      </h3>
    </header>

    <main class="row">
      <section class="col-xs-12 col-md-6 text-center">
        <img
          :src="characterImage"
          :alt="currentCharacter.name"
          class="img-fluid"
        />
      </section>

      <section class="col-xs-12 col-md-6">
        <p class="text-justify">Idade: {{ currentCharacter.age }}</p>

        <h4 class="mt-3">Bio</h4>
        <p class="text-justify">{{ currentCharacter.bio }}</p>
      </section>
    </main>
  </section>
</template>

<script>
export default {
  name: 'character',

  inject: ['universes'],

  computed: {
    currentUniverse() {
      return this.universes.find(
        universe => universe.slug === this.$route.params.slug
      )
    },

    currentCharacter() {
      return this.currentUniverse.characters.find(
        character => character.slug === this.$route.params.char
      )
    },

    characterImage() {
      return `/assets/img/characters/${this.currentCharacter.slug.toLowerCase()}.jpg`
    },
  },
}
</script>
